<!-- *ngIf="ready" -->
<ng-container>


    <ng-container>
        <div class="butonera">
            <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
              <mat-icon class="mat-icon-add-custom">add</mat-icon>
            </button>
        </div>

    </ng-container>

    <ng-container>
        <app-result-total *ngIf="dataResultTotals" [resultTotals]="dataResultTotals"></app-result-total>
        <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
            [actionsTemplate]="actionsButtons" [hasMonthFilter]="true"></app-table>

        <!-- <div class="container-fluid">
            <div class="row">
                <div class="col-md-2 col-lg-1 col-xs-12">
                    <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="getList()" class="form-control"
                        style="margin-left: 20px;">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                </div>
                <div class="col-md-10 col-lg-11 col-xs-12">
                    <pagination (pageChanged)="pageChanged($event)" [(ngModel)]="currentPage" [totalItems]="totalItems"
                        [itemsPerPage]="itemsPerPage" [maxSize]="5" previousText="Anterior"
                        style="float: right;margin-right: 20px;" nextText="Siguiente"></pagination>
                </div>
            </div>
        </div> -->
    </ng-container>

    <ng-container *ngIf="empty">
        <div class="text-center">
            <img src="assets/icons/concepto.svg" class="invoiceImage">
            <p style="color: #9e9e9e">No tiene ningún anticipo a proveedor, presione + para crear uno.</p>
        </div>
    </ng-container>



    <ng-template #actionsButtons let-uid="uid">
        <ul class="custom-class">
            <li (click)="assignExpense(uid)">
                <a>
                    <mat-icon>payment</mat-icon>Asignar gasto
                </a>
            </li>
            <li (click)="edit(uid)">
                <a>
                    <mat-icon>create</mat-icon>Editar
                </a>
            </li>
            <li (click)="delete(uid)">
                <a>
                    <mat-icon>warning</mat-icon>Borrar
                </a>
            </li>
        </ul>
    </ng-template>

</ng-container>

<ng-container *ngIf="ready === false">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
